import React from "react";

const ListingBroker = (props) => {
  return (
    <div className=" shadow-md border border-gray-200 rounded-lg p-6 flex flex-col px-4 py-6 lg:px-10 lg:py-12 border-t-2 lg:border-2 lg:rounded-sm mt-8 lg:mt-12 gap-5">
      {/* Broker Title */}
      <h3 className="text-lg font-semibold text-gray-700 font-poppins">Listing Broker</h3>

      {/* Broker Name */}
      <h2 className="text-2xl font-semibold text-gray-900 mt-1 font-poppins">
        {props.brokerName || "The Realty Experience Powered"}
      </h2>

      {/* Broker Details */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-4 text-sm text-gray-700">
        <div>
          <p className="font-semibold">Address:</p>
          <p className="text-gray-600">{props.address || "2483N Narcoossee..."}</p>
        </div>
        <div>
          <p className="font-semibold">City:</p>
          <p className="text-gray-600">{props.city || "Saint Cloud"}</p>
        </div>
        <div>
          <p className="font-semibold">State:</p>
          <p className="text-gray-600">{props.state || "Florida"}</p>
        </div>
        <div>
          <p className="font-semibold">Phone:</p>
          <p className="text-gray-600">{props.phone || "407-603-6008"}</p>
        </div>
      </div>
    </div>
  );
};

export default ListingBroker;
